import { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { authAPI, tokenManager } from '../lib/api'
import { Card, Logo } from '../components/ui'

type VerifyState = 'checking' | 'success' | 'error'

export default function VerifyEmail() {
  const { uidb64, token } = useParams<{ uidb64: string; token: string }>()
  const [verifyState, setVerifyState] = useState<VerifyState>('checking')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (!uidb64 || !token) {
      setVerifyState('error')
      setMessage('This verification link is malformed.')
      return
    }
    authAPI.verifyEmail(uidb64, token)
      .then((result) => {
        setMessage(result.detail)
        setVerifyState('success')
      })
      .catch((err: any) => {
        setMessage(err.message || 'This verification link is invalid or has expired.')
        setVerifyState('error')
      })
  }, [uidb64, token])

  return (
    <div
      className="relative flex min-h-screen w-full items-center justify-center p-4"
      style={{
        backgroundImage: 'url(/ISS_earth.avif)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/20 via-transparent to-black/40" />

      <Card className="relative z-10 w-full max-w-md gap-6 p-6 shadow-2xl">
        <div className="flex flex-col items-center gap-2 text-center">
          <Logo className="mx-auto h-7 w-[231px] max-w-full" />
          <h1 className="text-base font-normal text-muted-foreground">
            Email verification
          </h1>
        </div>

        {verifyState === 'checking' && (
          <p className="text-center text-sm text-muted-foreground">Confirming your email&hellip;</p>
        )}

        {verifyState === 'success' && (
          <div className="flex flex-col items-center gap-3 text-center">
            <div
              role="status"
              className="w-full rounded-lg border border-success/40 bg-success/10 px-3 py-2 text-sm text-success"
            >
              {message}
            </div>
            <Link
              to={tokenManager.isAuthenticated() ? '/home' : '/'}
              className="text-sm text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
            >
              Continue to Overmatch
            </Link>
          </div>
        )}

        {verifyState === 'error' && (
          <div className="flex flex-col items-center gap-3 text-center">
            <div
              role="alert"
              className="w-full rounded-lg border border-destructive/40 bg-destructive/10 px-3 py-2 text-sm text-destructive"
            >
              {message}
            </div>
            <Link
              to="/"
              className="text-sm text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
            >
              Back to login
            </Link>
          </div>
        )}

        <p className="text-center text-xs text-muted-foreground">
          DoW Acquisitions &amp; Vendor Evaluation Platform
        </p>
      </Card>
    </div>
  )
}
